import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import * as _ from 'lodash';
import * as moment from 'moment';

export class DapSpreadsheetSegmentInfluence extends Spreadsheet {
  name: string = 'segment_influence';

  mount (dataSource: any[]) {
    const totalSegments = dataSource[0].shareOfMarketShareInSegment.length;
    const totalFamilies = dataSource[0].tdbShareByDealerInMarkedArea.length;
    const totalMonths = dataSource[0].dapValuesFound.length;
    const initialValue = 10;

    const sections: Array<any> = [
      { key: 'main', text: '', index: 0 },
      { key: 'industryRetailRegistrationBySegment', text: 'INDUSTRY RETAIL REGISTRATION BY SEGMENT', index: initialValue },
      { key: 'industryRetailRegistrationByMarkedArea', text: 'INDUSTRY RETAIL REGISTRATION BY MARKED AREA', index: initialValue + totalSegments },
      { key: 'clientRetailRegistrationByMarkedArea', text: 'CLIENT RETAIL SALES BY MARKED AREA', index: initialValue + (totalSegments * 2) },
      { key: 'clientRetailRegistrationBySegment', text: 'CLIENT RETAIL SALES BY PRODUCT', index: initialValue + (totalSegments * 2) + totalFamilies },
      { key: 'shareOfMarketShareInSegment', text: 'SHARE OF THE MARKED AREA IN THE SEGMENT', index: initialValue + (totalSegments * 2) + (totalFamilies * 2) },
      { key: 'tdbShareByDealerInMarkedArea', text: 'TDB SHARE BY DEALER IN THE MARKED AREA', index: initialValue + (totalSegments * 3) + (totalFamilies * 2) },
      { key: 'segmentImpactInMarkedArea', text: 'PRODUCT IMPACT IN THE MARKED AREA', index: initialValue + (totalSegments * 3) + (totalFamilies * 3) },
      { key: 'dapValuesFoundNormalized', text: 'MONTHLY ANNUAL PLAN - NORMALIZED', index: initialValue + (totalSegments * 3) + (totalFamilies * 4) },
      { key: 'dapValuesFound', text: 'MONTHLY ANNUAL PLAN', index: initialValue + (totalSegments * 3) + (totalFamilies * 4) + totalMonths }
    ];

    const sectionColumns: any = {
      main: [
        { key: 'dealerNumber', text: 'DN' },
        { key: 'dealerName', text: 'NAME' },
        { key: 'storeType', text: 'TYPE' },
        { key: 'groupName', text: 'GROUP' },
        { key: 'markedAreaName', text: 'MARKED AREA' },
        { key: 'region', text: 'REGION' },
        { key: 'aov', text: 'AOV' },
        { key: 'regionale', text: 'REGIONAL' },
        { key: 'marketLevelName', text: 'MARKET SHARE REFERENCE' },
        { key: 'tdbShareResult', text: 'TDB SHARE RESULT', format: '#0.0%', color: 'yellow' }
      ],
      industryRetailRegistrationBySegment: [
        ..._.map(dataSource[0].industryRetailRegistrationBySegment, (s: any) => ({ key: 'value', text: s.segmentName, format: '#,0' }))
      ],
      industryRetailRegistrationByMarkedArea: [
        ..._.map(dataSource[0].industryRetailRegistrationByMarkedArea, (s: any) => ({ key: 'value', text: s.segmentName, format: '#,0' }))
      ],
      clientRetailRegistrationByMarkedArea: [
        ..._.map(dataSource[0].clientRetailRegistrationByMarkedArea, (s: any) => ({ key: 'value', text: s.familyName, format: '#,0' }))
      ],
      clientRetailRegistrationBySegment: [
        ..._.map(dataSource[0].clientRetailRegistrationBySegment, (s: any) => ({ key: 'value', text: s.familyName, format: '#,0' }))
      ],
      shareOfMarketShareInSegment: [
        ..._.map(dataSource[0].shareOfMarketShareInSegment, (s: any) => ({ key: 'value', text: s.segmentName, format: '#0.0%' }))
      ],
      tdbShareByDealerInMarkedArea: [
        ..._.map(dataSource[0].tdbShareByDealerInMarkedArea, (s: any) => ({ key: 'value', text: s.familyName, format: '#0.0%' }))
      ],
      segmentImpactInMarkedArea: [
        ..._.map(dataSource[0].segmentImpactInMarkedArea, (s: any) => ({ key: 'value', text: s.familyName, format: '#0.0%' }))
      ],
      dapValuesFoundNormalized: [
        ..._.map(dataSource[0].dapValuesFoundNormalized, () => ({ key: 'value', text: 'SALES GOAL', format: '#0.00%' }))
      ],
      dapValuesFound: [
        ..._.map(dataSource[0].dapValuesFound, () => ({ key: 'value', text: 'SALES GOAL', format: '#,0' }))
      ]
    };

    const sectionColumnsDateTime: any = {
      main: [
        { key: 'dealerNumber', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase() }
      ],
      industryRetailRegistrationBySegment: [
        { key: 'segmentName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue }
      ],
      industryRetailRegistrationByMarkedArea: [
        { key: 'segmentName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + totalSegments }
      ],
      clientRetailRegistrationByMarkedArea: [
        { key: 'familyName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + (totalSegments * 2) }
      ],
      clientRetailRegistrationBySegment: [
        { key: 'familyName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + (totalSegments * 2) + totalFamilies }
      ],
      shareOfMarketShareInSegment: [
        { key: 'segmentName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + (totalSegments * 2) + (totalFamilies * 2) }
      ],
      tdbShareByDealerInMarkedArea: [
        { key: 'familyName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + (totalSegments * 3) + (totalFamilies * 2) }
      ],
      segmentImpactInMarkedArea: [
        { key: 'familyName', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), index: initialValue + (totalSegments * 3) + (totalFamilies * 3) }
      ],
      dapValuesFoundNormalized: [
        ..._(dataSource[0].dapValuesFound)
          .map((d: any, i: number) => ({ key: 'year', text: String(d.year), index: initialValue + (totalSegments * 3) + (totalFamilies * 4) + i }))
          .uniqBy((d: any) => d.text)
          .value()
      ],
      dapValuesFound: [
        ..._(dataSource[0].dapValuesFound)
          .map((d: any, i: number) => ({ key: 'year', text: String(d.year), index: initialValue + (totalSegments * 3) + (totalFamilies * 4) + totalMonths + i }))
          .uniqBy((d: any) => d.text)
          .value()
      ]
    };

    const sectionColumnsDescription: any = {
      main: [
        { key: 'dealerNumber', text: '', index: 0 },
        { key: 'tdbShareResult', text: 'F*[∑(F*G)+(F*G)]', index: initialValue - 1 }
      ],
      industryRetailRegistrationBySegment: [
        { key: 'segmentName', text: 'A', index: initialValue }
      ],
      industryRetailRegistrationByMarkedArea: [
        { key: 'segmentName', text: 'B', index: initialValue + totalSegments }
      ],
      clientRetailRegistrationByMarkedArea: [
        { key: 'familyName', text: 'C', index: initialValue + (totalSegments * 2) }
      ],
      clientRetailRegistrationBySegment: [
        { key: 'familyName', text: 'D', index: initialValue + (totalSegments * 2) + totalFamilies }
      ],
      shareOfMarketShareInSegment: [
        { key: 'segmentName', text: 'E=B/A', index: initialValue + (totalSegments * 2) + (totalFamilies * 2) }
      ],
      tdbShareByDealerInMarkedArea: [
        { key: 'familyName', text: 'F=D/C', index: initialValue + (totalSegments * 3) + (totalFamilies * 2) }
      ],
      segmentImpactInMarkedArea: [
        { key: 'familyName', text: 'G', index: initialValue + (totalSegments * 3) + (totalFamilies * 3) }
      ],
      dapValuesFoundNormalized: [
        ..._.map(dataSource[0].dapValuesFoundNormalized, (d: any, i: number) => ({
          key: 'month',
          text: moment().startOf('year').add(d.month - 1, 'months').format('MMM').toUpperCase(),
          index: initialValue + (totalSegments * 3) + (totalFamilies * 4) + i
        }))
      ],
      dapValuesFound: [
        ..._.map(dataSource[0].dapValuesFound, (d: any, i: number) => ({
          key: 'month',
          text: moment().startOf('year').add(d.month - 1, 'months').format('MMM').toUpperCase(),
          index: initialValue + (totalSegments * 3) + (totalFamilies * 4) + totalMonths + i
        }))
      ]
    };

    const baseStyle: any = {
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      main: '#bdbdbd',
      industryRetailRegistrationBySegment: '#90a4ae',
      industryRetailRegistrationByMarkedArea: '#e57373',
      clientRetailRegistrationByMarkedArea: '#90a4ae',
      clientRetailRegistrationBySegment: '#e57373',
      shareOfMarketShareInSegment: '#90a4ae',
      tdbShareByDealerInMarkedArea: '#e57373',
      segmentImpactInMarkedArea: '#90a4ae',
      dapValuesFoundNormalized: '#e57373',
      dapValuesFound: '#90a4ae',
      grey: '#d1d1d1',
      greyDarken: '#c1c1c1',
      yellow: '#ffb74d'
    };

    const baseBorderColorStyle: any = {
      main: '#e0e0e0',
      industryRetailRegistrationBySegment: '#cfd8dc',
      industryRetailRegistrationByMarkedArea: '#ffcdd2',
      clientRetailRegistrationByMarkedArea: '#cfd8dc',
      clientRetailRegistrationBySegment: '#ffcdd2',
      shareOfMarketShareInSegment: '#cfd8dc',
      tdbShareByDealerInMarkedArea: '#ffcdd2',
      segmentImpactInMarkedArea: '#cfd8dc',
      dapValuesFoundNormalized: '#ffcdd2',
      dapValuesFound: '#cfd8dc',
      yellow: '#ffe0b2'
    };

    const baseBackgroundColorStyle: any = {
      main: '#fafafa',
      industryRetailRegistrationBySegment: '#f9fafb',
      industryRetailRegistrationByMarkedArea: '#fff5f6',
      clientRetailRegistrationByMarkedArea: '#f9fafb',
      clientRetailRegistrationBySegment: '#fff5f6',
      shareOfMarketShareInSegment: '#f9fafb',
      tdbShareByDealerInMarkedArea: '#fff5f6',
      segmentImpactInMarkedArea: '#f9fafb',
      dapValuesFoundNormalized: '#fff5f6',
      dapValuesFound: '#f9fafb',
      yellow: '#fffbf5'
    };

    const headerStyle = _.reduce(baseColorStyle, (acc: any, val: string, key: string) => {
      acc[key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[key] });
      return acc;
    }, {});

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    const dataSourceGroup = _(dataSource)
      .groupBy(d => d.familyName)
      .value();

    this.name = `dap_${_.map(dataSourceGroup, (val: any, key: string) => key.toLowerCase()).join('_')}_${this.name}`;

    this.workbookOptions = {
      sheets: _.map(dataSourceGroup, (data: any, name: string) => (
        {
          name: `IMPACTO SEGMENTO ${name}`.toUpperCase(),
          frozenColumns: 2,
          frozenRows: 4,
          filter: {
            ref: `A4:${this.columnIndex[initialValue - 1 + (totalSegments * 5) + (totalFamilies * 2) + (totalMonths * 2)]}${data.length + 4}`,
            columns: []
          },
          rows: [
            {
              cells: [
                ..._.map(sections, (section: any) =>
                  _.assign({}, headerStyle[section.key], {
                    value: section.text,
                    index: section.index,
                    borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                    borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                  }))
              ]
            },
            {
              cells: [
                ..._(sectionColumnsDateTime)
                  .map((columns: any, key: any) =>
                    _.map(columns, (cell: any) =>
                      _.assign({}, getCellStyle(cell.color || key), {
                        value: cell.text,
                        bold: true,
                        index: cell.index,
                        background: baseColorStyle.grey,
                        borderLeft: { color: baseBorderColorStyle.main, size: 1 },
                        borderRight: { color: baseBorderColorStyle.main, size: 1 },
                        borderTop: { color: baseBorderColorStyle.main, size: 1 },
                        borderBottom: { color: baseBorderColorStyle.main, size: 1 }
                      })))
                  .flatten()
                  .value()
              ]
            },
            {
              cells: [
                ..._(sectionColumnsDescription)
                  .map((columns: any, key: any) =>
                    _.map(columns, (cell: any) =>
                      _.assign({}, getCellStyle(cell.color || key), {
                        value: cell.text,
                        bold: true,
                        index: cell.index,
                        background: baseColorStyle.greyDarken,
                        borderLeft: { color: baseBorderColorStyle.main, size: 1 },
                        borderRight: { color: baseBorderColorStyle.main, size: 1 },
                        borderTop: { color: baseBorderColorStyle.main, size: 1 },
                        borderBottom: { color: baseBorderColorStyle.main, size: 1 }
                      })))
                  .flatten()
                  .value()
              ]
            },
            {
              height: 80,
              cells: [
                ..._(sectionColumns)
                  .map((columns: any, key: any) =>
                    _.map(columns, (cell: any) =>
                      _.assign({}, headerStyle[cell.color || key], {
                        value: cell.text,
                        wrap: true,
                        borderLeft: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                        borderRight: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                        borderTop: { color: baseBorderColorStyle[cell.color || key], size: 1 },
                        borderBottom: { color: baseBorderColorStyle[cell.color || key], size: 1 }
                      })))
                  .flatten()
                  .value()
              ]
            },
            ..._.map(data, d => {
              return ({
                cells: [
                  ..._(sectionColumns)
                    .map((columns: any, key: any) =>
                      _.map(columns, (cell: any, index: number) => {
                        if ([
                          'industryRetailRegistrationBySegment',
                          'industryRetailRegistrationByMarkedArea',
                          'clientRetailRegistrationByMarkedArea',
                          'clientRetailRegistrationBySegment',
                          'shareOfMarketShareInSegment',
                          'tdbShareByDealerInMarkedArea',
                          'segmentImpactInMarkedArea',
                          'dapValuesFoundNormalized',
                          'dapValuesFound'
                        ].some((k: string) => key === k)) {
                          return _.assign({}, getCellStyle(cell.color || key), ({
                            value: d[key][index][cell.key],
                            format: cell.format
                          }));
                        }
                        return _.assign({}, getCellStyle(cell.color || key), {
                          value: d[cell.key],
                          format: cell.format
                        });
                      }))
                    .flatten()
                    .value()
                ]
              });
            })
          ],
          columns: [
            {
              index: 0,
              width: 100
            },
            {
              index: 1,
              width: 200
            },
            {
              index: 2,
              width: 75
            },
            {
              index: 3,
              width: 100
            },
            {
              index: 4,
              width: 200
            },
            {
              index: 5,
              width: 100
            },
            {
              index: 6,
              width: 75
            },
            ..._.map(_.range(0, initialValue + (totalSegments * 5) + (totalFamilies * 2) + (totalMonths * 2)), index => ({
              index: index + 7,
              width: 75
            }))
          ],
          showGridLines: false,
          mergedCells: [
            `A1:${this.columnIndex[initialValue - 1]}1`,
            `A2:${this.columnIndex[initialValue - 1]}2`,
            `A3:${this.columnIndex[initialValue - 2]}3`,
            `${this.columnIndex[sections[1].index]}1:${this.columnIndex[sections[2].index - 1]}1`,
            `${this.columnIndex[sections[2].index]}1:${this.columnIndex[sections[3].index - 1]}1`,
            `${this.columnIndex[sections[3].index]}1:${this.columnIndex[sections[4].index - 1]}1`,
            `${this.columnIndex[sections[4].index]}1:${this.columnIndex[sections[5].index - 1]}1`,
            `${this.columnIndex[sections[5].index]}1:${this.columnIndex[sections[6].index - 1]}1`,
            `${this.columnIndex[sections[6].index]}1:${this.columnIndex[sections[7].index - 1]}1`,
            `${this.columnIndex[sections[7].index]}1:${this.columnIndex[sections[8].index - 1]}1`,
            `${this.columnIndex[sections[8].index]}1:${this.columnIndex[sections[9].index - 1]}1`,
            `${this.columnIndex[sections[9].index]}1:${this.columnIndex[sections[9].index + totalMonths - 1]}1`,
            `${this.columnIndex[sections[1].index]}2:${this.columnIndex[sections[2].index - 1]}2`,
            `${this.columnIndex[sections[2].index]}2:${this.columnIndex[sections[3].index - 1]}2`,
            `${this.columnIndex[sections[3].index]}2:${this.columnIndex[sections[4].index - 1]}2`,
            `${this.columnIndex[sections[4].index]}2:${this.columnIndex[sections[5].index - 1]}2`,
            `${this.columnIndex[sections[5].index]}2:${this.columnIndex[sections[6].index - 1]}2`,
            `${this.columnIndex[sections[6].index]}2:${this.columnIndex[sections[7].index - 1]}2`,
            `${this.columnIndex[sections[7].index]}2:${this.columnIndex[sections[8].index - 1]}2`,
            ..._.map(sectionColumnsDateTime.dapValuesFoundNormalized, (c: any) => `${this.columnIndex[c.index]}2:${this.columnIndex[c.index - 1 + ((_(dataSource[0].dapValuesFoundNormalized).groupBy((d: any) => d.year).find((val: any, key: string) => +key === +c.text) as any).length)]}2`),
            ..._.map(sectionColumnsDateTime.dapValuesFound, (c: any) => `${this.columnIndex[c.index]}2:${this.columnIndex[c.index - 1 + ((_(dataSource[0].dapValuesFound).groupBy((d: any) => d.year).find((val: any, key: string) => +key === +c.text) as any).length)]}2`),
            `${this.columnIndex[sections[1].index]}3:${this.columnIndex[sections[2].index - 1]}3`,
            `${this.columnIndex[sections[2].index]}3:${this.columnIndex[sections[3].index - 1]}3`,
            `${this.columnIndex[sections[3].index]}3:${this.columnIndex[sections[4].index - 1]}3`,
            `${this.columnIndex[sections[4].index]}3:${this.columnIndex[sections[5].index - 1]}3`,
            `${this.columnIndex[sections[5].index]}3:${this.columnIndex[sections[6].index - 1]}3`,
            `${this.columnIndex[sections[6].index]}3:${this.columnIndex[sections[7].index - 1]}3`,
            `${this.columnIndex[sections[7].index]}3:${this.columnIndex[sections[8].index - 1]}3`
          ]
        }
      ) as any)
    };

    return this;
  }
}
